import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Cell, Bar, LabelList } from 'recharts';
import { Container } from 'react-bootstrap';
import { ChartPie, ChartStackedBar } from '../Charts';
import { NoImage, CustomizedLabel } from '../Utils';
import './style.scss';

class ReadingReport extends Component {
  constructor() {
    super();
    this.state = {};
  }

  formatNumber = data => {
    if (data === 0) {
      return '';
    }
    return `${data}%`;
  };

  renderTypeOfChart = (chart, styleChart, data, styles2) => {
    if (data.graph_type === 4) {
      return (
        <ChartPie dataChart={chart} ticks={[0, 50, 100]}>
          {styleChart.map((entry, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Cell key={`cell-${index}`} fill={entry.colour} />
          ))}
        </ChartPie>
      );
    }
    if (data.graph_type === 5) {
      const doneStyles = new Set();
      return data && styleChart[0] ? (
        <ChartStackedBar
          styleChart={styleChart}
          styles2={styles2}
          dataChart={chart}
          ticks={[0, 50, 100]}
          name={85}
        >
          {styleChart.map(chartX => {
            return chartX.map(style => {
              if (!doneStyles.has(style.id)) {
                doneStyles.add(style.id);
                return (
                  <Bar
                    dataKey={style.id}
                    stackId="a"
                    fill={style.colour}
                    maxBarSize={50}
                    isAnimationActive={false}
                  >
                    <LabelList
                      dataKey={style.id}
                      position="center"
                      formatter={value => this.formatNumber(value)}
                      content={<CustomizedLabel color={style.colour} />}
                    />
                  </Bar>
                );
              }
              return null;
            });
          })}
        </ChartStackedBar>
      ) : (
        <NoImage />
      );
    }
    return <NoImage />;
  };

  renderChart = () => {
    const { data } = this.props;
    return data ? (
      data.map((chart, index) => {
        const dataForChart = chart.data;
        const styleForChart = chart.styles;
        const { styles2 } = chart;
        return (
          <div
            id={`chart-${index + 1}`}
            className={
              chart.graph_type === 5 ? 'div-chart' : 'div-chart-reading'
            }
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          >
            <p className="p-chart-reading">
              <span className="title-chart-reading">{chart.title}</span>
              <br />
              <span className="subtitle-chart-reading">{chart.subtitle}</span>
            </p>
            {this.renderTypeOfChart(
              dataForChart,
              styleForChart,
              chart,
              styles2
            )}
            <hr className="myhrline" />
          </div>
        );
      })
    ) : (
      <center>
        <NoImage />
      </center>
    );
  };

  render() {
    return (
      <Container className="container-charts mt-4">
        <h2 className="title-report">Informe de Lectura</h2>
        {this.renderChart()}
      </Container>
    );
  }
}

const mapStateToProps = state => {
  const { availableYears, ongoingRequest } = state.utils;
  return {
    availableYears,
    ongoingRequest
  };
};

export default connect(mapStateToProps)(ReadingReport);
